import { render, staticRenderFns } from "./XeroAccountSettingsForm.vue?vue&type=template&id=a0a857ca&scoped=true&"
import script from "./XeroAccountSettingsForm.vue?vue&type=script&lang=js&"
export * from "./XeroAccountSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./XeroAccountSettingsForm.vue?vue&type=style&index=0&id=a0a857ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a857ca",
  null
  
)

export default component.exports